const DEFAULT_QUANTITY = "1";

export const updateConsumablesMatrixQuantitySearchParam = (currentSticksURL: string, quantity: string) => {
  const paramString = window.location.search ? window.location.search.slice(1) : "";
  const searchParams = new URLSearchParams(paramString);

  if (quantity === DEFAULT_QUANTITY) {
    searchParams.delete("quantity");
  } else {
    searchParams.set("quantity", quantity);
  }

  const queryString = searchParams.toString();
  const nextURL = queryString ? `${currentSticksURL}?${queryString}` : currentSticksURL;

  if (nextURL === window.location.href) return;

  window.history.replaceState(null, "", nextURL);
};
